import React from "react"
import "./style.scss"
import Loading from '../../Icons/monophy.gif'

const LocalLoading = () => {
	return (
		<>
			<div className="loader-data">
        	<div className="loader-back">
        		<div className="loader-rect">
        			<div className="loader-lines-hor">
        				<div />
        				<div />
        				<div />
        				<div />
        				<div />
        			</div>
        			<div className="loader-lines-ver">
        				<div />
        				<div />
        				<div />
        				<div />
        				<div />
        			</div>
        		</div>
        	</div>
        	<div className="loader-white">
        		<div className="loader-white-lines">
        			<div />
        			<div />
        			<div />
        			<div />
        			<div />
        		</div>
        	</div>
        	<img
        		className="loader-svg"
        		decoding="async"
        		loading="lazy"
        		src={ Loading }
        	/>
			</div>
		</>
	)
}

export default LocalLoading